import type { NavigateFunction } from 'react-router-dom';

import { BASENAME_URL_COOKIES_POLICIES } from 'constants/settings';

import type { TCookiesType } from 'types/cookies';

export const routeToCookiePolicy = (navigate: NavigateFunction, type: TCookiesType) => {
    navigate(BASENAME_URL_COOKIES_POLICIES, { state: { type } });
};
